import { useState } from "react";
import { User, UserAdd } from "@/types/user";
import { userAdd } from "@/apis/user";
import { notification } from "antd";
import { useTranslation } from "react-i18next";
import errorCodes from "@/apis/error";

type AddUser = (props: UserAdd) => Promise<User>

type IUserAdd = () => [ boolean, { addUser: AddUser } ]

const useUserAdd:IUserAdd = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false)

  const addUser: AddUser = (props) => {
    setLoading(true)
    return new Promise((resolve) => {
      userAdd(props)
        .then((user) => {
          setLoading(false)
          resolve(user)
        })
        .catch((err) => {
          notification.error({ placement: 'top', message: t('member.addFailed'), description: errorCodes[err] || err })
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }

  return [loading, { addUser }]
}

export default useUserAdd;